var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94444 4.94444H11.2556M4.94444 8.1H9.67778M12.8333 1C13.461 1 14.063 1.24934 14.5068 1.69318C14.9507 2.13702 15.2 2.73899 15.2 3.36667V9.67778C15.2 10.3055 14.9507 10.9074 14.5068 11.3513C14.063 11.7951 13.461 12.0444 12.8333 12.0444H8.88889L4.94444 14.4111V12.0444H3.36667C2.73899 12.0444 2.13702 11.7951 1.69318 11.3513C1.24934 10.9074 1 10.3055 1 9.67778V3.36667C1 2.73899 1.24934 2.13702 1.69318 1.69318C2.13702 1.24934 2.73899 1 3.36667 1H12.8333Z",
    stroke: "#51CDA0",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.25646c7080a4c13d50b5b211f0003985.svg";
export { ForwardRef as ReactComponent };